import classNames from 'classnames'

const Button = ({ title = '', disabled = false, handler = null, className = '' }) => {
  return (
    <button
      onClick={handler}
      disabled={disabled}
      className={classNames('btn btn_black', className)}
      type="button"
    >
      {title}
    </button>
  )
}

export default Button
